import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  AuthCookieService,
  AuthService,
  IdleService,
  SignalRService,
} from '@vinnova/auth';
import { BetalningsuppgiftReminderService } from '@vinnova/e-tjanster';
import { TranslateService } from '@vinnova/translation';
import { environment } from '../environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private authCookieService: AuthCookieService,
    private signalRService: SignalRService,
    private idleService: IdleService,
    private translateService: TranslateService,
    private betalningsuppgiftReminderService: BetalningsuppgiftReminderService,
  ) {}

  ngOnInit() {
    this.authService
      .onLoggedIn([this.idleService.initIdle()])
      .pipe(untilDestroyed(this))
      .subscribe();

    this.authService
      .onLoggedIn()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.signalRService.init(
          [
            `https://${environment.b2cMsalConfig.tenant}.onmicrosoft.com/${environment.b2cMsalConfig.clientId.etjansterCommonApiClientId}/all`,
          ],
          environment.b2cMsalConfig.authority,
        );
        this.betalningsuppgiftReminderService.showBetalningsuppgiftReminderModal();
      });

    this.translateService
      .setActiveLang()
      .pipe(untilDestroyed(this))
      .subscribe();

    this.authCookieService
      .tokenSuccess()
      .pipe(untilDestroyed(this))
      .subscribe();
  }
}
